import React from 'react';
import { useHistory } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import DataTable from '../../../sharedModules/dataTable/DataTable/DataTable';
import { IDataTableColumn } from '../../../sharedModules/dataTable/DataTable/model';

interface VendorRow {
  id: number;
  vendor: string;
  address: string;
  phone: string;
  earliest: string;
  location: string;
  hot: boolean;
}

const MOCK_VENDORS: VendorRow[] = [
  { id: 1, vendor: 'AAON Inc.', address: '2425 S Yukon Ave, Tulsa, OK 74107', phone: '918-583-2266', earliest: '03/18/2026 08:00', location: 'WH-A', hot: true },
  { id: 2, vendor: 'Carrier Corporation', address: '13995 Pasteur Blvd, Palm Beach Gardens, FL 33418', phone: '800-227-7437', earliest: '03/19/2026 10:30', location: 'WH-B', hot: false },
  { id: 3, vendor: 'Trane Technologies', address: '3600 Pammel Creek Rd, La Crosse, WI 54601', phone: '608-787-2000', earliest: '03/20/2026 09:00', location: 'WH-A', hot: false },
  { id: 4, vendor: 'Daikin Applied Americas', address: '13600 Industrial Park Blvd, Plymouth, MN 55441', phone: '763-553-5330', earliest: '03/17/2026 14:00', location: 'WH-C', hot: true },
  { id: 5, vendor: 'York / Johnson Controls', address: '5005 York Drive, Norman, OK 73069', phone: '405-364-4040', earliest: '03/21/2026 11:00', location: 'WH-B', hot: false },
  { id: 6, vendor: 'Lennox International', address: '2140 Lake Park Blvd, Richardson, TX 75080', phone: '972-497-5000', earliest: '03/22/2026 07:30', location: 'WH-A', hot: false },
];

const conditionalRowStyles = [
  {
    when: (row: VendorRow) => row.hot,
    style: {
      backgroundColor: 'rgba(255, 200, 0, 0.3)',
      fontWeight: 'bold',
      '&:hover': {
        backgroundColor: 'rgba(255, 200, 0, 0.45)',
      },
    },
  },
];

const WarehousePickupVendorListPage: React.FC = () => {
  const history = useHistory();

  const columns: IDataTableColumn<VendorRow>[] = [
    {
      name: 'Earliest',
      selector: 'earliest',
      sortable: true,
      grow: 0.8,
    },
    {
      name: 'Vendor',
      selector: 'vendor',
      sortable: true,
      grow: 1.2,
    },
    {
      name: 'Address',
      selector: 'address',
      sortable: false,
      grow: 2,
      wrap: true,
    },
    {
      name: 'Phone',
      selector: 'phone',
      sortable: false,
      grow: 0.8,
      cell: (row: VendorRow) => (
        <a href={`tel:${row.phone}`} onClick={(e) => e.stopPropagation()}>
          {row.phone}
        </a>
      ),
    },
    {
      name: 'Location',
      selector: 'location',
      sortable: true,
      grow: 0.5,
    },
  ];

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h5" fontWeight="bold">
          Warehouse Pickups
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          Yellow rows indicate urgent vendors. Click a vendor to view open POs.
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <DataTable
          columns={columns}
          data={MOCK_VENDORS}
          onRowClicked={(row: VendorRow) => history.push(`/employee_portal/warehouse_pickup/vendors/${row.id}/pos`)}
          highlightOnHover
          pointerOnHover
          striped
          dense={false}
          conditionalRowStyles={conditionalRowStyles}
          noHeader
          responsive
        />
      </Grid>
    </Grid>
  );
};

export default WarehousePickupVendorListPage;
